import { BusinessCategory } from "src/entities/BusinessCategory";

const createBusinessCategories = (
  businessCategories?: BusinessCategory[],
  selectedCategories?: string[]
) => {
  const businessCategoriesReq = new Array<BusinessCategory>();

  // eslint-disable-next-line array-callback-return
  selectedCategories?.map((value) => {
    const businessCategory = businessCategories?.find(
      (category) => category.name === value
    );
    businessCategoriesReq.push(businessCategory);
  });

  return businessCategoriesReq;
};

// New function specifically for API calls that returns string IDs
export const createBusinessCategoryIds = (
  businessCategories?: BusinessCategory[],
  selectedCategories?: string[]
): string[] => {
  const businessCategoryIds: string[] = [];

  selectedCategories?.forEach((value) => {
    const businessCategory = businessCategories?.find(
      (category) => category.name === value
    );
    if (businessCategory?.id) {
      businessCategoryIds.push(businessCategory.id);
    }
  });

  return businessCategoryIds;
};

export default createBusinessCategories;
